var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',{ref:"container"},[_vm._v("\n        店铺账单\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }